import template from './storyNotFound.template.html'

export default {
  restrict: 'E',
  replace: false,
  template,
  controllerAs: 'vm',
  controller: 'StoryNotFoundController',
}
